import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { injectIntl } from "react-intl";
import { useQuery, useMutation, queryCache } from "react-query";
import * as Yup from "yup";
import Alert from 'react-s-alert';
import PageLoading from "../../../components/Loading";
import { InputFloatingLabel } from "../../../formik";
import ArchiveHeader from "../../../components/ArchiveHeader";
import { getSchedule, postSchedule, putSchedule } from '../schedules/xhr';
import { cleanObjectAndReturn } from "../../../helpers/cleanObject"

const ThemeForm = ({  intl, match, history, locale, setLocale}) => {

  const editForm = match.params.id ? true : false;

  const { isLoading, isError, error, data: schedule } = useQuery('schedule', getSchedule, {
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  const [postScheduleMutation] = useMutation(postSchedule, {
    onSuccess: (createdSchedule) => {
      if(queryCache.getQueryData('schedule')) {
        queryCache.setQueryData('schedule', schedule => ({
          ...schedule,
          colors: schedule.colors.concat([createdSchedule])
        }));
      }
      Alert.success(intl.formatMessage({id: 'color.create-success'}));
      history.push("/themes");
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })
  const addTheme = async (values) => {
    Alert.warning(intl.formatMessage({id: "alert.s.color.create_do"}));
    await postScheduleMutation({collection: 'color', schedule: cleanObjectAndReturn(values)})
  };

  const [putScheduleMutation] = useMutation(putSchedule, {
    onSuccess: (updatedSchedule) => {
      if(queryCache.getQueryData('schedule')) {
        queryCache.setQueryData('schedule', schedule => ({
          ...schedule,
          colors: schedule.colors.map(color => color._id === updatedSchedule._id ? updatedSchedule : color)
        }))
      }
      Alert.success(intl.formatMessage({ id: 'color.update-success' }));
      history.push("/themes");
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })

  const editTheme = async (values) => {
    Alert.warning(intl.formatMessage({id: "alert.s.color.update_do"}));
    await putScheduleMutation({ collection: 'color',  _id:match.params.id , schedule:cleanObjectAndReturn(values) })
  }

  if (isLoading) {
    return <PageLoading />;
  }

  if (isError) {
    return <span>Error: {error.message}</span>
  }

  return (
    <React.Fragment>
      <ArchiveHeader locale={locale} setLocale={setLocale} intl={intl} title={editForm ? "button.s.color-update":"button.s.color-create"} back backLink="/themes" />
      <div className="pad-2rem">
        <Container fluid>
          <Row>
            <Col md={4}>
              <Formik
                validationSchema={
                  Yup.object().shape({
                    name: Yup.string().required(),
                    color: Yup.string().required(),
                  })
                }
                initialValues={editForm
                  ? {
                    ...schedule.colors.find(
                      r => r._id === match.params.id
                    )
                  }
                  : {
                    name: match.params.name ? match.params.name : '',
                    color: ''
                  }}
                enableReinitialize={true}
                onSubmit={async ({ name, color }) => {
                  editForm ? 
                    editTheme({ name, color })
                  : addTheme({ name, color });
                }}
              >
                {({ values }) => {
                  return (
                    <Form className="floating-label-form">
                      <Field
                        component={InputFloatingLabel}
                        type="text"
                        name="name"
                        id="name"
                        placeholder={intl.formatMessage({
                          id: "input.name"
                        })}
                        label={intl.formatMessage({
                          id: "input.name"
                        })}
                        required
                      />
                      <Field
                        component={InputFloatingLabel}
                        type="color"
                        name="color"
                        placeholder={intl.formatMessage({
                          id: "input.color.color"
                        })}
                        // label={intl.formatMessage({
                        //   id: "input.color.color"
                        // })}
                        id="color"
                        required
                      />
                      <Button
                        type="submit"
                        variant="primary"
                      >
                        {editForm ? intl.formatMessage({ id: `button.s.color-update` }) : intl.formatMessage({ id: `button.s.color-create` })}
                      </Button>
                    </Form>
                  )
                }}
              </Formik>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};



export default injectIntl(ThemeForm);
